$(function(){
  // setTimeout(function(){
    /*
    $('.mw-option').each(function(i,e){
      $(e).find('.mw-option__control').change(function(){
        value = $(this).val();
        console.log(value);
      });
    });*/

    //console.log(mwApoInit.response);
  // },300);

  
  // 商品詳細
  // $(document).on('change', '#select_o_642739', function(){
  //   value = $(this).val();
  //   $(this).children('option').each(function(i,e){
  //     if(value == $(e).attr('value')){
  //       localStorage.setItem('test', $(e).text());
  //     }
  //   });
  // });
  //フォーム
  // console.log(window.mwApoInit);
  /*
  var intervalId = setInterval(function(){
    if($('#test-optionname').length){
      // console.log(sessionStorage.getItem('rfqItem'));
      $('#test-optionname').val(sessionStorage.getItem('rfqItem'));
      // clearInterval(intervalId);
    }else{
      // console.log('none');
    }
  },100);*/
});